import {Injectable} from '@angular/core';
import {IAnnouncementsHttpService} from './announcements-http.service.interface';
import {AnnouncementModel} from '../models/announcement-model';
import {environment} from '../../../../environments/environment';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../shared/services/my-http-client.service';

@Injectable()
export class AnnouncementsHttpService extends IAnnouncementsHttpService {

    // http: MyHttpClient


   public async getAnnouncements(): Promise<AnnouncementModel[]> {
        const response = await firstValueFrom(
            this.httpClient.get<{ announcements: AnnouncementModel[] }>(
                `${this.serverAddress}/v1/announcements`
            )
        );
        return response.announcements;
    }

    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3140190228/CONFIRM+Announcements+for+User+v1
    public async confirmAnnouncements(announcements: AnnouncementModel[]): Promise<void> {
        // convert announcements to request, use only ids
        const request: { confirmedAnnouncements: number[] } = {
            confirmedAnnouncements: announcements.map(announcement => announcement.id)
        };
        await firstValueFrom(
            this.httpClient.put<any>(
                `${this.serverAddress}/v1/confirmedAnnouncements`,
                request
            )
        );
    }

}
